export const selectDefaultRoute = (s) => s?.navigation?.defaultRoute ?? [];

export const selectVerificationConfiguration = (s) => s?.general?.verificationConfiguration;

export const selectIdErrorMsg = (s) => s?.general?.idErrorMsg;

export const selectResendSentAt = (s) => s?.general?.resendSentAt ?? {};

export const selectSessionTimer = (s) => s?.general?.sessionTimer;

export const selectCaptureQualityFailureCount = (s) => s?.general?.captureQualityFailureCount ?? 0;
